import templatelist from '../../../playturbo/src/lang/ja/templateList'
import versionlist from '../../../playturbo/src/lang/ja/versionList'
import login from '../../../playturbo/src/lang/ja/login'
import forget from '../../../playturbo/src/lang/ja/forget'
import profile from '../../../playturbo/src/lang/ja/profile'
import navbar from '../../../playturbo/src/lang/ja/navbar'
import ptCommon from '../../../playturbo/src/lang/ja/common'
import custom from '../../../playturbo/src/lang/ja/custom'
import creative from '../../../playturbo/src/lang/ja/creative'
import websocket from '../../../playturbo/src/lang/ja/websocket'
import uploader from './ja/uploader'
import cropperDialog from './ja/cropperDialog'
import frameSelectDialog from './ja/frameSelectDialog'
import gamePlay from '../../../playturbo/src/lang/ja/gamePlay'
import report from '../../../playturbo/src/lang/ja/report'
import common from './ja/common.js'
import commonTemplate from '../../../playturbo/src/lang/ja/commonTemplate.js'
import deliveryList from '../../../playturbo/src/lang/ja/deliveryList'
import dispatcher from '../../../playturbo/src/lang/ja/dispatcher'
import privacy from '../../../playturbo/src/lang/ja/privacy'
import commonNavbar from './ja/downloadBasic'
import basic from '@com/lang/ja/basic'
import workbench from '@com/lang/ja/workbench'
import userJourney from '@com/lang/ja/userJourney'
import resourceManager from '@com/lang/ja/resourceManager'
import record from '@pt/lang/ja/record'
import account from '@pt/lang/ja/account'
import guideTour from '@pt/lang/ja/guideTour'
import home from '@pt/lang/ja/home'
import leftMenu from '@pt/lang/ja/leftMenu'
import navbarTool from '@pt/lang/ja/navbarTool'
import whole from '@pt/lang/ja/whole'
import assetLibrary from '@pt/lang/ja/assetLibrary'
import exportHistory from '@pt/lang/ja/exportHistory'
import picturesVideos from '@pt/lang/ja/picturesVideos'
import playableAds from '@pt/lang/ja/playableAds'
import playableProject from '@pt/lang/ja/playableProject'
import promoteManagement from '@pt/lang/ja/promoteManagement'
import recordManagement from '@pt/lang/ja/recordManagement'
import recordProject from '@pt/lang/ja/recordProject'
import templateLibrary from '@pt/lang/ja/templateLibrary'
import videoProject from '@pt/lang/ja/videoProject'
import dashboard from '@pt/lang/ja/dashboard'
import ce from '@pt/lang/ja/ce'
import locale from '@ve-pro/ve/lang/locales/ja.json'
import taskCenter from '@pt/lang/ja/taskCenter'
import pushDialog from '@pt/lang/ja/pushDialog'
import authAccount from '@pt/lang/ja/authAccount'
import billing from '@pt/lang/ja/billing'
import activities from '@pt/lang/ja/activities'
import rev from '@pt/lang/ja/rev'
import preView from '@ps/lang/ja/preview'
import trial from '@pt/lang/ja/trial'
import register from '@pt/lang/ja/register'
import order from '@pt/lang/ja/order'
import permission from '@pt/lang/ja/permission'
import payment from '@pt/lang/ja/payment'
import voiceLab from '@pt/lang/ja/voiceLab'
import aiBanner from '@pt/lang/ja/aiBanner'
import aiLocale from '@ai/lang/locales/ja.json'

// 引入视频编辑器国家化内容，由于视频编辑器key体系之后一级，配置在playTurbo字段会导致无法生成国际化配置，手动拼接playTurbo key名称引入到i18n根目录
const vePro = {}
Object.keys(locale).forEach((key) => {
  vePro['playTurbo.' + key] = locale[key]
})

export default {
  basic,
  workbench,
  userJourney,
  resourceManager,

  commonNavbar,
  form: {
    platform: 'プラットフォーム',
    type: 'タイプ',
    starttime: 'スタートタイム',
    timeseparator: 'から',
    endtime: 'エンドタイム',
    keyword: 'キーワード',
    search: '検索',
    pastWeek: '直近1週間',
    pastMonth: '直近1ヶ月',
    past3Month: '直近3ヶ月',
    pastHalfYear: '直近6ヶ月',
    pastYear: '直近1年',
  },
  common,
  uploader,
  cropperDialog,
  frameSelectDialog,
  playTurbo: {
    navbar,
    login,
    forget,
    profile,
    trial,
    register,
    templatelist,
    versionlist,
    common: ptCommon,
    commonTemplate,
    pushDialog,
    authAccount,
    custom,
    creative,
    gamePlay,
    report,
    deliveryList,
    websocket,
    dispatcher,
    privacy,
    record,
    account,
    guideTour,
    home,
    leftMenu,
    navbarTool,
    whole,
    ce,
    assetLibrary,
    exportHistory,
    picturesVideos,
    playableAds,
    playableProject,
    promoteManagement,
    recordManagement,
    recordProject,
    templateLibrary,
    videoProject,
    dashboard,
    taskCenter,
    billing,
    activities,
    rev,
    order,
    permission,
    payment,
    voiceLab,
    aiBanner,
  },
  preview: {
    preView,
  },
  ...vePro,
  ai: aiLocale,
}
